import styled, { css } from 'styled-components';

import { RemoteBrandLogo23 } from 'remote-com-shared/components/Brand/Logo';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

const RemoteLogo = styled(RemoteBrandLogo23)`
  ${tabletBreakpoint(css`
    display: none;
  `)}
`;

export default RemoteLogo;
